import { Alert, AlertTitle } from '@ori-ui/mui';
import { alertStyle, alertTitleStyle } from "./styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var defaultErrorMessageTitle = 'Error';
export var ErrorMessage = function ErrorMessage(_ref) {
  var children = _ref.children,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? defaultErrorMessageTitle : _ref$title;
  return /*#__PURE__*/_jsxs(Alert, {
    severity: "error",
    sx: alertStyle,
    variant: "outlined",
    children: [/*#__PURE__*/_jsx(AlertTitle, {
      sx: alertTitleStyle,
      children: title
    }), children]
  });
};
//# sourceMappingURL=ErrorMessage.js.map